import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { WelcomePlannerViewService } from '../../../../services';

@Component({
  selector: 'app-welcome-planner-button',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './welcome-planner-button.component.html',
  styleUrls: ['./welcome-planner-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WelcomePlannerButtonComponent {
  private _welcomePlannerViewService = inject(WelcomePlannerViewService);
  private _customRouteService = inject(CustomRouteService);

  protected isAllReadyViewShown = this._welcomePlannerViewService.isAllReadyViewShown;
  
  protected handleGoToPlannerClick() {
    this._customRouteService.setIsWelcomeViewShown(false);
    this._welcomePlannerViewService.setIsAllReadyViewShown(true);
  }
}
